import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

interface TestimonialHeaderProps {
  title: string;
  subtitle: string;
}

export const TestimonialHeader: React.FC<TestimonialHeaderProps> = ({ title, subtitle }) => {
  return (
    <div>
      <motion.div 
        className="flex items-center space-x-2 mb-4"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
      >
        <div className="flex space-x-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="w-4 h-4 text-yellow-500 fill-current" />
          ))}
        </div>
        <span className="text-white/90 text-sm">Perfect Score</span>
      </motion.div>

      <motion.h2 
        className="text-4xl font-bold mb-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {title}
      </motion.h2>
      <motion.p 
        className="text-gray-300"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        {subtitle}
      </motion.p>
    </div>
  );
};